(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const initHeroParallax = (section) => {
      const mediaGrid = section.querySelector('.hero__media-grid');
      if (!mediaGrid) return;

      const speed = parseFloat(section.dataset.parallaxSpeed) || 40;
      let ticking = false;

      const update = () => {
        const rect = section.getBoundingClientRect();
        const progress = rect.top / window.innerHeight;
        const offset = progress * speed;
        mediaGrid.style.transform = `translateY(${offset}px)`;
        ticking = false;
      };

      const onScroll = () => {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    };

    const initAll = () => {
      document.querySelectorAll('.hero[data-parallax="true"]').forEach(initHeroParallax);
    };

    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
